import {useMutation} from "react-query";
import {UpdateRoleCommand} from "../../models/user";
import roleService from "../../services/RoleService";

export default function useUpdateRole() {
   return useMutation((request: UpdateRoleCommand) => roleService.update(request));
}